import React, { useCallback, useEffect, useState } from 'react';

import { ForgotPasswordStep } from 'features/authentication/SignIn/constants';
import { ErrorTrackingProps } from 'features/authentication/SignIn/types';

import { EVENT_ACTIONS, TRACK_ACTION_TYPES } from 'util/tracking_constants';
import { useExtendUx, useTrackUx } from 'util/uxEvents';

import EmailCodeForm from './Steps/EmailCodeForm';
import EmailFormContainer from './Steps/EmailFormContainer';
import NewPasswordForm from './Steps/NewPasswordForm';

type Props = {
  onSuccess: () => void;
} & ErrorTrackingProps;

const ForgotPasswordFlow = ({ onError, onSuccess }: Props) => {
  const [step, setStep] = useState(ForgotPasswordStep.EMAIL);
  const [email, setEmail] = useState('');
  const [emailId, setEmailId] = useState('');
  const trackUx = useTrackUx();
  const extendUx = useExtendUx();

  useEffect(() => {
    trackUx(EVENT_ACTIONS.PAGE_VIEWED, TRACK_ACTION_TYPES.VIEW);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  extendUx({ view: step });

  // TODO: https://joinhomebase.atlassian.net/browse/FE-2199
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const handleSetStep = useCallback(view => setStep(view), []);

  const handleSetEmail = useCallback((email: string) => setEmail(email), []);

  // TODO: https://joinhomebase.atlassian.net/browse/FE-2199
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const handleSetEmailId = useCallback(id => setEmailId(id), []);

  switch (step) {
    case ForgotPasswordStep.EMAIL:
      return (
        <EmailFormContainer
          onSetStep={handleSetStep}
          onSetEmail={handleSetEmail}
          onSetEmailId={handleSetEmailId}
          onError={onError}
        />
      );
    case ForgotPasswordStep.CODE:
      return (
        <EmailCodeForm
          email={email}
          emailId={emailId}
          onSetStep={handleSetStep}
          onSetEmailId={handleSetEmailId}
          onError={onError}
          onSuccess={onSuccess}
        />
      );
    case ForgotPasswordStep.PASSWORD:
    default:
      return <NewPasswordForm onError={onError} />;
  }
};

export default ForgotPasswordFlow;
